import { useContext } from "react";
import { useStore } from "@densityco/lib-state-management";

import { StoreContext } from "components/store-provider";

export function useAppStore() {
  const [store] = useContext(StoreContext);
  return useStore(store);
}
